import CMSection from '@src/components/Atoms/CMSection';
import SevenCard from '@src/components/Molecules/Sponser/SevenCard';
import { devices } from '@src/styles/theme';
import styled from 'styled-components';

const Seven = () => {
  return (
    <CMSection backgroundColor="#fff">
      <Wrap>
        <BigTitle>후원 Q&A</BigTitle>
        <SevenCard />
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  padding: 110px 0;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center; */
  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;

const BigTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  white-space: pre-wrap;
  padding-bottom: 60px;
  @media ${devices.tablet} {
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
    padding-bottom: 0;
  }
`;

export default Seven;
